import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { ExecutionNode, XMLCard } from 'pages/Chat/MarkdownRender';
import { styled } from '@mui/material/styles';
import { PropsTable } from 'pages/Chat/QuantModeTable';
import { MOBILE_BREAK_POINTS } from 'data/constant';

const WarningBox = styled(Box)(({ theme }) => ({
	backgroundColor: '#EBEBEB',
	padding: '12px 20px',
	borderRadius: 7,
	marginBottom: theme.spacing(2),
	display: 'flex',
	alignItems: 'center',
	fontWeight: 500,
	fontSize: 14,
	borderLeftWidth: 5,
	borderLeftStyle: 'solid',
	color: '#333',
	borderLeftColor: '#1C4ED8',
}));

const ResponsiveTypography = styled(Typography)(({ theme }) => ({
	fontWeight: 600,
	color: '#4C535A',

	[`@media (max-width:${MOBILE_BREAK_POINTS}px)`]: {
		fontWeight: 500,
		fontSize: theme.typography.caption.fontSize,
		lineHeight: theme.typography.caption.lineHeight,
	},
}));

const SectionCard: React.FC<{ title?: string; children: React.ReactNode }> = ({
	title,
	children,
}) => (
	<Card variant="outlined" sx={{ margin: 0, borderWidth: 0, padding: 0 }}>
		<CardContent sx={{ padding: '16px 8px' }}>
			{title && (
				<Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
					{title}
				</Typography>
			)}
			{children}
		</CardContent>
	</Card>
);

const CardRenderer: React.FC<{ card: XMLCard }> = ({ card }) => (
	<SectionCard title={card.title}>
		{!!card.props.length && <PropsTable propsList={card.props} />}
		{!!card.sections.length && (
			<Box>
				{card.sections.map((sec, i) => (
					<SectionCard key={`sec-${i}`} title={sec.title}>
						{!!sec.props.length && (
							<PropsTable propsList={sec.props} />
						)}
						{!!sec.notes.length && (
							<Box component="ul" sx={{ pl: 3, m: 0 }}>
								{sec.notes.map((n, idx) => (
									<ResponsiveTypography
										key={idx}
										variant="body2"
									>
										{n}
									</ResponsiveTypography>
								))}
							</Box>
						)}
					</SectionCard>
				))}
			</Box>
		)}
		{!!card.notes.length && (
			<>
				{card.notes.map((n, i) => (
					<WarningBox key={`${n} + ${i}`}>
						<ResponsiveTypography key={i} variant="body2">
							{n}
						</ResponsiveTypography>
					</WarningBox>
				))}
			</>
		)}
	</SectionCard>
);

export const ExecutionChat: React.FC<{ node: ExecutionNode }> = ({ node }) => {
	return (
		<>
			{node.cards.map((c, i) => (
				<CardRenderer key={`analysis-${i}`} card={c} />
			))}
		</>
	);
};
